export default __webpack_public_path__ + "static/media/1.Fire-Fighting-pump-set.aa75006c.PNG";